module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABZUlEQVQ4ja3Uz0uVQRTG8Y9xwfIHFS0SCcSFmAQRBUnYIty0rGX/RcvZu7pDC6WFtSwICloVbVuoIFyNoEUiElxXQkSIN1oY2XUx88JNvPqi7wPDO2fOmS8z855zeur1uhK6iDF8xt9ORwjhv8BaCdgAvmAPZ/EIC92Cz5QA3sMmRhHwEj2nAU7ga56/wiUMnwY4jUae/+sYJwJO4RbeZfsCzuHnSYBjeIPH2M5rI9jCn26baujH5Wz/wg/p3T7iKV53xDfRl9daEGMsfN8xX8NGDmrn7x28wCyeHDhAC5N4gN4Dvhv4UJP+2AB+S/k1jOt41uVWTcwVRpHYMcYhrB31hu0jfIfpGppl0qasbmO1auBK1cBGJcAY4xUMYr2qE97HYghhryrgQ7zn8NJrYxfny5BijFdxF29JpdfCktRBxrEj9bxPUt0epxHMhBC2C+BNqXnK8FUs47nU+47TZgjhW2HsA1txTzfHF7Y7AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhuzhou/icon8.png
// module id = 3Xv6
// module chunks = 1